// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_jjV","clinicsSelect":"styles_clinicsSelect__1eAmq"};